import { createSlice } from "@reduxjs/toolkit";

export const complianceSlice = createSlice({
  name: "compliance",
  initialState: {
    isGettingComplianceList: false,
    getComplianceListMessage: null,
    getComplianceListError: null,
    complianceList: null,
    isGettingComplianceControls: false,
    getComplianceControlsMessage: null,
    getComplianceControlsError: null,
    complianceControls: null,
    isGettingComplianceResources: false,
    getComplianceResourcesMessage: null,
    getComplianceResourcesError: null,
    complianceResources: null,
    selectedResource: null,
    isGettingComplianceTags: false,
    getComplianceTagsMessage: null,
    getComplianceTagsError: null,
    complianceTags: null,
    isGettingComplianceControlSections: false,
    getComplianceControlSectionsMessage: null,
    getComplianceControlSectionsError: null,
    complianceControlSections: null,
    complianceControlSectionsRunId: null,
    isCreatingComplianceWorkload: false,
    createComplianceWorkloadMessage: null,
    createComplianceWorkloadError: null,
    createdComplianceWorkload: null,
    isEditingComplianceWorkload: false,
    editComplianceWorkloadMessage: null,
    editComplianceWorkloadError: null,
    editedComplianceWorkload: null,
    isDeletingComplianceWorkload: false,
    deleteComplianceWorkloadMessage: null,
    deleteComplianceWorkloadError: null,
    deletedComplianceWorkload: null,
    isInitiatingComplianceScan: false,
    initiateComplianceScanMessage: null,
    initiateComplianceScanError: null,
    initiatedComplianceScan: null,
    isDownloadingComplianceReport: false,
    downloadComplianceReportMessage: null,
    downloadComplianceReportError: null,
    downloadedComplianceReport: null,
  },
  reducers: {
    getComplianceList: (state) => {
      state.isGettingComplianceList = true;
      state.getComplianceListMessage = null;
      state.getComplianceListError = null;
    },
    getComplianceListSuccessful: (state, action) => {
      state.isGettingComplianceList = false;
      state.getComplianceListMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getComplianceListError = null;
      const { status, ...complianceData } = action.payload;
      state.complianceList = complianceData;
    },
    getComplianceListFailure: (state, action) => {
      state.isGettingComplianceList = false;
      state.getComplianceListMessage = null;
      state.getComplianceListError = action.payload.message;
    },
    getComplianceControls: (state) => {
      state.isGettingComplianceControls = true;
      state.getComplianceControlsMessage = null;
      state.getComplianceControlsError = null;
    },
    getComplianceControlsSuccessful: (state, action) => {
      state.isGettingComplianceControls = false;
      state.getComplianceControlsMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getComplianceControlsError = null;
      const { status, ...complianceControlsData } = action.payload;
      state.complianceControls = complianceControlsData;
    },
    getComplianceControlsFailure: (state, action) => {
      state.isGettingComplianceControls = false;
      state.getComplianceControlsMessage = null;
      state.getComplianceControlsError = action.payload.message;
    },
    getComplianceResources: (state) => {
      state.isGettingComplianceResources = true;
      state.getComplianceResourcesMessage = null;
      state.getComplianceResourcesError = null;
    },
    getComplianceResourcesSuccessful: (state, action) => {
      state.isGettingComplianceResources = false;
      state.getComplianceResourcesMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getComplianceResourcesError = null;
      const { status, ...resourcesData } = action.payload;
      state.complianceResources = resourcesData;
    },
    getComplianceResourcesFailure: (state, action) => {
      state.isGettingComplianceResources = false;
      state.getComplianceResourcesMessage = null;
      state.getComplianceResourcesError = action.payload.message;
    },
    setSelectedResource: (state, action) => {
      state.selectedResource = action.payload;
    },
    clearSelectedResource: (state) => {
      state.selectedResource = null;
    },
    createComplianceWorkload: (state) => {
      state.isCreatingComplianceWorkload = true;
      state.createComplianceWorkloadMessage = null;
      state.createComplianceWorkloadError = null;
    },
    createComplianceWorkloadSuccessful: (state, action) => {
      state.isCreatingComplianceWorkload = false;
      state.createComplianceWorkloadMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.createComplianceWorkloadError = null;
      state.createdComplianceWorkload = action.payload;
    },
    createComplianceWorkloadFailure: (state, action) => {
      state.isCreatingComplianceWorkload = false;
      state.createComplianceWorkloadMessage = null;
      state.createComplianceWorkloadError = action.payload.message;
    },
    editComplianceWorkload: (state) => {
      state.isEditingComplianceWorkload = true;
      state.editComplianceWorkloadMessage = null;
      state.editComplianceWorkloadError = null;
    },
    editComplianceWorkloadSuccessful: (state, action) => {
      state.isEditingComplianceWorkload = false;
      state.editComplianceWorkloadMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.editComplianceWorkloadError = null;
      state.editedComplianceWorkload = action.payload;
    },
    editComplianceWorkloadFailure: (state, action) => {
      state.isEditingComplianceWorkload = false;
      state.editComplianceWorkloadMessage = null;
      state.editComplianceWorkloadError = action.payload.message;
    },
    deleteComplianceWorkload: (state) => {
      state.isDeletingComplianceWorkload = true;
      state.deleteComplianceWorkloadMessage = null;
      state.deleteComplianceWorkloadError = null;
    },
    deleteComplianceWorkloadSuccessful: (state, action) => {
      state.isDeletingComplianceWorkload = false;
      state.deleteComplianceWorkloadMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.deleteComplianceWorkloadError = null;
      state.deletedComplianceWorkload = action.payload;
    },
    deleteComplianceWorkloadFailure: (state, action) => {
      state.isDeletingComplianceWorkload = false;
      state.deleteComplianceWorkloadMessage = null;
      state.deleteComplianceWorkloadError = action.payload.message;
    },
    clearComplianceControls: (state) => {
      state.complianceControls = null;
      state.isGettingComplianceControls = false;
      state.getComplianceControlsMessage = null;
      state.getComplianceControlsError = null;
    },
    clearAllComplianceMessages: (state) => {},
    clearAllComplianceMessagesSuccessful: (state) => {
      state.getComplianceListMessage = null;
      state.getComplianceListError = null;
      state.getComplianceControlsMessage = null;
      state.getComplianceControlsError = null;
      state.getComplianceResourcesMessage = null;
      state.getComplianceResourcesError = null;
      state.createComplianceWorkloadMessage = null;
      state.createComplianceWorkloadError = null;
      state.editComplianceWorkloadMessage = null;
      state.editComplianceWorkloadError = null;
      state.deleteComplianceWorkloadMessage = null;
      state.deleteComplianceWorkloadError = null;
      state.initiateComplianceScanMessage = null;
      state.initiateComplianceScanError = null;
      state.getComplianceTagsMessage = null;
      state.getComplianceTagsError = null;
      state.downloadComplianceReportMessage = null;
      state.downloadComplianceReportError = null;
    },
    initiateComplianceScan: (state) => {
      state.isInitiatingComplianceScan = true;
      state.initiateComplianceScanMessage = null;
      state.initiateComplianceScanError = null;
    },
    initiateComplianceScanSuccessful: (state, action) => {
      state.isInitiatingComplianceScan = false;
      state.initiateComplianceScanMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.initiateComplianceScanError = null;
      state.initiatedComplianceScan = action.payload;
    },
    initiateComplianceScanFailure: (state, action) => {
      state.isInitiatingComplianceScan = false;
      state.initiateComplianceScanMessage = null;
      state.initiateComplianceScanError = action.payload.message;
    },
    getComplianceTags: (state) => {
      state.isGettingComplianceTags = true;
      state.getComplianceTagsMessage = null;
      state.getComplianceTagsError = null;
    },
    getComplianceTagsSuccessful: (state, action) => {
      state.isGettingComplianceTags = false;
      state.getComplianceTagsMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getComplianceTagsError = null;
      const { status, ...tagsData } = action.payload;
      state.complianceTags = tagsData;
    },
    getComplianceTagsFailure: (state, action) => {
      state.isGettingComplianceTags = false;
      state.getComplianceTagsMessage = null;
      state.getComplianceTagsError = action.payload.message;
    },
    getComplianceControlSections: (state, action) => {
      state.isGettingComplianceControlSections = true;
      state.complianceControlSectionsRunId = action.payload?.runId || null;
      state.getComplianceControlSectionsMessage = null;
      state.getComplianceControlSectionsError = null;
    },
    getComplianceControlSectionsSuccessful: (state, action) => {
      const forRunId = action.payload?.forRunId || null;
      if (forRunId && state.complianceControlSectionsRunId && forRunId !== state.complianceControlSectionsRunId) return;
      state.isGettingComplianceControlSections = false;
      state.getComplianceControlSectionsMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getComplianceControlSectionsError = null;
      const sectionsData = { ...action.payload };
      delete sectionsData.status;
      delete sectionsData.forRunId;
      state.complianceControlSections = sectionsData;
      if (forRunId) state.complianceControlSectionsRunId = forRunId;
    },
    getComplianceControlSectionsFailure: (state, action) => {
      state.isGettingComplianceControlSections = false;
      state.getComplianceControlSectionsMessage = null;
      state.getComplianceControlSectionsError = action.payload.message;
    },
    downloadComplianceReport: (state) => {
      state.isDownloadingComplianceReport = true;
      state.downloadComplianceReportMessage = null;
      state.downloadComplianceReportError = null;
    },
    downloadComplianceReportSuccessful: (state, action) => {
      console.log("🚀 ~ action:", action)
      state.isDownloadingComplianceReport = false;
      state.downloadComplianceReportMessage = action.payload || 'Success';
      state.downloadComplianceReportError = null;
      state.downloadedComplianceReport = action.payload;
    },
    downloadComplianceReportFailure: (state, action) => {
      state.isDownloadingComplianceReport = false;
      state.downloadComplianceReportMessage = null;
      state.downloadComplianceReportError = action.payload.message;
    },
  }
});

export const {
  getComplianceList,
  getComplianceListSuccessful,
  getComplianceListFailure,
  getComplianceControls,
  getComplianceControlsSuccessful,
  getComplianceControlsFailure,
  getComplianceResources,
  getComplianceResourcesSuccessful,
  getComplianceResourcesFailure,
  getComplianceTags,
  getComplianceTagsSuccessful,
  getComplianceTagsFailure,
  getComplianceControlSections,
  getComplianceControlSectionsSuccessful,
  getComplianceControlSectionsFailure,
  clearComplianceControls,
  clearAllComplianceMessages,
  clearAllComplianceMessagesSuccessful,
  setSelectedResource,
  clearSelectedResource,
  createComplianceWorkload,
  createComplianceWorkloadSuccessful,
  createComplianceWorkloadFailure,
  editComplianceWorkload,
  editComplianceWorkloadSuccessful,
  editComplianceWorkloadFailure,
  deleteComplianceWorkload,
  deleteComplianceWorkloadSuccessful,
  deleteComplianceWorkloadFailure,
  initiateComplianceScan,
  initiateComplianceScanSuccessful,
  initiateComplianceScanFailure,
  downloadComplianceReport,
  downloadComplianceReportSuccessful,
  downloadComplianceReportFailure,
} = complianceSlice.actions;

export default complianceSlice.reducer;
